import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { DashboardProvider } from "./context/dashboard-context";
import { AuthProvider } from "./context/auth-context";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import Login from "./pages/Login/Login";
import UserDetail from "./pages/UserDetail/UserDetail";
import ViewContract from "./pages/ViewContract/ViewContract";
import DeviceDetail from "./pages/DeviceDetail/DeviceDetail";
import Producers from "./pages/Producers/Producers";
import Notification from "./pages/Notification/Notification";
import DeviceList from "./pages/DeviceList/DeviceList";
import Organizations from "./pages/Organizations/Organizations";
import OrganizationDetail from "./pages/OrganizationDetail/OrganizationDetail";
import UserList from "./pages/UserList/UserList";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <div className="main-wrapper">
                <App />
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-list"
          element={
            <ProtectedRoute>
              <div className="main-wrapper">
                <UserList />
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-list/:id"
          element={
            <ProtectedRoute>
              <div className="main-wrapper">
                <UserDetail />
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-detail"
          element={
            <ProtectedRoute>
              <div className="main-wrapper">
                <UserDetail />
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-contract"
          element={
            <ProtectedRoute>
              <div className="main-wrapper">
                <ViewContract />
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/devices"
          element={
            <ProtectedRoute>
              <div className="main-wrapper">
                <DeviceList />
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/devices/:id"
          element={
            <ProtectedRoute>
              <div className="main-wrapper">
                <DeviceDetail />
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/producers"
          element={
            <ProtectedRoute>
              <div className="main-wrapper">
                <Producers />
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/notification-center"
          element={
            <ProtectedRoute>
              <div className="main-wrapper">
                <Notification />
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/organizations"
          element={
            <ProtectedRoute>
              <div className="main-wrapper">
                <Organizations />
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/organizations/:id"
          element={
            <ProtectedRoute>
              <div className="main-wrapper">
                <OrganizationDetail />
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <DashboardProvider>
      <AppRoutes />
    </DashboardProvider>
  </AuthProvider>
);
